import { DestroyRef, inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { EMPTY, Observable } from 'rxjs';
import { LoggerService } from '../services/logger.service';
import { DataAuthFactory } from '../factories/data-auth.factory';
import { EnAuthOptionsOperator } from '../enums/auth-options-operator.enum';
import { AuthOptions } from '../models/auth-options.model';
import { uuid } from '@shared/utils/uuid.utils';
import { COMPONENT_STATE } from '../di/component-state.token';
import { ComponentState } from '../interfaces/component-state.interface';

@Injectable()
export abstract class AbstractCoreComponent {
  private readonly _uuid: string;
  protected readonly logger = inject(LoggerService);
  protected readonly router = inject(Router);
  protected readonly store = inject(Store);
  protected readonly destroyRef = inject(DestroyRef);

  protected readonly state: ComponentState | null = inject(COMPONENT_STATE, { optional: true });

  readonly name = this.constructor.name;

  constructor() {
    this._uuid = uuid();
    this.logger.debug(this.name, this._uuid);
  }

  protected createAuthOptions(value: string | string[], operator = EnAuthOptionsOperator.AND): AuthOptions {
    return DataAuthFactory.create(value, operator);
  }

  protected createExactAuthOptions(value: string | string[], operator = EnAuthOptionsOperator.AND): AuthOptions {
    return DataAuthFactory.createExact(value, operator);
  }

  protected handleCatchError(error: any): Observable<never> {
    this.logger.error(this.name, 'Errore', error);
    return EMPTY;
  }

  get uuid(): string {
    return this._uuid;
  }
}
